import Watchlist from './Watchlist'

export default Watchlist;